import { useState } from "react";
import { ThumbsUp, ThumbsDown } from "lucide-react";
import api from "../lib/api";
import { toast } from "sonner";

export default function FeedbackWidget({ runId, projectId }) {
  const [rating, setRating] = useState(null);
  const [comment, setComment] = useState("");
  const [done, setDone] = useState(false);

  const submit = async (r) => {
    setRating(r);
    if (r === "up") {
      await api.post("/feedback", { rating: r, run_id: runId, project_id: projectId });
      setDone(true);
      toast.success("Thanks — glad it helped.");
    }
  };

  const submitComment = async () => {
    await api.post("/feedback", { rating, comment, run_id: runId, project_id: projectId });
    setDone(true);
    toast.success("Thanks — our experts review every note.");
  };

  if (done) return <p className="text-sm text-[#475569] text-center py-4" data-testid="feedback-done">Feedback recorded — thank you.</p>;

  return (
    <div className="bg-white border border-[#0B1F3A]/15 rounded-lg p-5 text-center" data-testid="feedback-widget">
      <p className="font-serif font-semibold text-[#0B1F3A]">Was this roadmap complete for your project?</p>
      <div className="flex justify-center gap-3 mt-3">
        <button onClick={() => submit("up")} className={`p-2.5 rounded-full border transition-colors ${rating === "up" ? "bg-[#0B1F3A] text-white" : "border-[#0B1F3A]/30 hover:border-[#059669]"}`} data-testid="feedback-up-btn" aria-label="Yes, complete">
          <ThumbsUp size={18} />
        </button>
        <button onClick={() => setRating("down")} className={`p-2.5 rounded-full border transition-colors ${rating === "down" ? "bg-[#0B1F3A] text-white" : "border-[#0B1F3A]/30 hover:border-[#059669]"}`} data-testid="feedback-down-btn" aria-label="Something missing">
          <ThumbsDown size={18} />
        </button>
      </div>
      {rating === "down" && (
        <div className="mt-3 max-w-md mx-auto">
          <input value={comment} onChange={(e) => setComment(e.target.value)} placeholder="What was missing? (optional, one line)"
            className="w-full bg-white border border-[#0B1F3A]/20 rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-[#059669] focus:outline-none" data-testid="feedback-comment-input" />
          <button onClick={submitComment} className="mt-2 bg-[#1D4ED8] text-white rounded-md px-4 py-2 text-sm font-medium hover:bg-[#1638A8]" data-testid="feedback-submit-btn">Send feedback</button>
        </div>
      )}
    </div>
  );
}
